/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipAutoDialerAPI extends WhatsAppSipApiClient {
  constructor() {
    super('autodialer');
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns
  getCampaigns(params = {}) {
    return axios.get(`${this.url}/campaigns`, { params });
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id
  showCampaign(id) {
    return axios.get(`${this.url}/campaigns/${id}`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns
  createCampaign(data) {
    return axios.post(`${this.url}/campaigns`, data);
  }

  // PUT /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id
  updateCampaign(id, data) {
    return axios.put(`${this.url}/campaigns/${id}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id
  deleteCampaign(id) {
    return axios.delete(`${this.url}/campaigns/${id}`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/start
  startCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/start`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/pause
  pauseCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/pause`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/resume
  resumeCampaign(id) {
    return axios.post(`${this.url}/campaigns/${id}/resume`);
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/contacts
  getContacts(campaignId, params = {}) {
    return axios.get(`${this.url}/campaigns/${campaignId}/contacts`, {
      params,
    });
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/contacts
  addContacts(campaignId, contacts) {
    return axios.post(`${this.url}/campaigns/${campaignId}/contacts`, {
      contacts,
    });
  }

  // PUT /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/contacts
  replaceContacts(campaignId, contacts) {
    return axios.put(`${this.url}/campaigns/${campaignId}/contacts`, {
      contacts,
    });
  }

  // DELETE /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/contacts/:contactId
  removeContact(campaignId, contactId) {
    return axios.delete(
      `${this.url}/campaigns/${campaignId}/contacts/${contactId}`
    );
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/stats
  getStats(campaignId) {
    return axios.get(`${this.url}/campaigns/${campaignId}/stats`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/autodialer/preflight_contacts
  preflightContacts(phones) {
    return axios.post(`${this.url}/preflight_contacts`, { phones });
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/schedules
  getSchedules(campaignId) {
    return axios.get(`${this.url}/campaigns/${campaignId}/schedules`);
  }

  // DELETE /api/v1/accounts/:account_id/whatsapp_sip/autodialer/campaigns/:id/schedules/:scheduleId
  cancelSchedule(campaignId, scheduleId) {
    return axios.delete(
      `${this.url}/campaigns/${campaignId}/schedules/${scheduleId}`
    );
  }
}

export default new WhatsAppSipAutoDialerAPI();
